
























/**
 * adgroup 编辑、复制时的提示信息
 * 数据维护在 useAdgroupAlertInfo文件的全局环境
 * alertInfo 中有值，就会展示，点击 x 会自动清除所有提示信息
 *
 * 增加一条信息展示
 * 1. 引入方法：const { addAlertInfo } = useAdgroupAlertInfo();
 * 2. 调用传入 message： addAlertInfo({ key: string, message: Object })
 * 3. message 格式：{ label: '', content: '' }，展示为 label: content，content 支持 string 或 vNode 类型
 *
 * 展示
 * 1. 顺序，会根据 OrderEnum 数组进行展示，未在 OrderEnum 中定义的会按默认顺序展示
 * 2. 格式，label: content
 *
 * 主动清除
 * 1. 引入方法：const { clearAlertInfo } = useAdgroupAlertInfo();
 * 2. 调用 clearAlertInfo 即可
 * clearAlertInfo() 清除所有
 * clearAlertInfo(keys) // keys => ['foo'] 只清除key 为foo的info
 *
 * slot
 * 1. title：整个提示的标题
 * 2. content: 提示内容，prop为content
 * 3. control：展开折叠的控制
 *
 * props
 * 1. title: 整个提示的标题
 */
import { ref, computed, defineComponent } from '@vue/composition-api';
import { useAdgroupAlertInfo } from '@tt4b/ttam-hooks';
import VNodeRenderer from '@/components/common/node-renderer/index.vue';

const OrderEnum = ['device-model', 'bid-strategy', 'pixel-event'];

const name = 'ttam-alert-info';

export default defineComponent({
  name,
  components: { VNodeRenderer },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { alertInfo, clearAlertInfo } = useAdgroupAlertInfo();

    const unfold = ref(true);

    const info = computed(() => {
      const orderedInfo = [];
      OrderEnum.forEach(key => {
        if (!alertInfo.value?.[key]) {
          return;
        }
        orderedInfo.push(alertInfo.value[key]);
      });
      for (const key of Object.keys(alertInfo.value)) {
        if (OrderEnum.includes(key as string)) {
          continue;
        }
        orderedInfo.push(alertInfo.value[key]);
      }

      return orderedInfo;
    });

    const visible = computed(() => Boolean(info.value?.length));

    function onClose() {
      clearAlertInfo(undefined);
    }

    function onChangeFoldStatus() {
      unfold.value = !unfold.value;
    }

    return {
      name,
      info,
      visible,
      unfold,
      onClose,
      onChangeFoldStatus,
    };
  },
});
